import { TimeseriesDataPoint } from "@/features/charts/types";

/**
 * Helper function to extract a number value from various possible types
 */
export function extractNumberValue(value: any): number | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'object' && 'our' in value) {
    return value.our;
  }

  return null;
}


/**
 * Calculates average metrics from TimeseriesDataPoint array (main property)
 */
export function calculateAverageMetrics(dataPoints: TimeseriesDataPoint[]) {
  if (!dataPoints || dataPoints.length === 0) {
    return { avgPrice: 0, avgRank: 0 };
  }

  let totalPrice = 0;
  let totalRank = 0;
  let count = 0;

  dataPoints.forEach(point => {
    if (point.price && typeof point.price === 'object' && 'our' in point.price) {
      totalPrice += point.price.our || 0;
      totalRank += point.rank.our || 0;
      count++;
    }
  });

  return {
    avgPrice: count > 0 ? totalPrice / count : 0,
    avgRank: count > 0 ? totalRank / count : 0
  };
}

/**
 * Calculates average metrics from competitor data points
 */
export function calculateCompetitorAverageMetrics(dataPoints: any[]) {
  if (!dataPoints || dataPoints.length === 0) {
    return { avgPrice: 0, avgRank: 0 };
  }

  let totalPrice = 0;
  let totalRank = 0;
  let count = 0;

  dataPoints.forEach(point => {
    const price = extractNumberValue(point.price);
    const rank = extractNumberValue(point.rank);

    if (price !== null) {
      totalPrice += price;
      count++;
    }

    if (rank !== null) {
      totalRank += rank;
    }
  });

  return {
    avgPrice: count > 0 ? totalPrice / count : 0,
    avgRank: count > 0 ? totalRank / count : 0
  };
}